export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";